import { useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { openGroupGiftRedemptionModal } from 'registry/modals/actions'
import { InfoButton } from 'components/buttons'
import { NumberSelect } from 'components/forms'
import { GROUP_GIFT_ACTIONS } from 'registry/constants'
import InStockAlertButton from 'store/components/in-stock-alert-button'
import classnames from 'classnames'
import { AddToBabylistCartButton } from './buttons/add-to-babylist-cart-button'
import { ExternalStoreBuyButton } from './buttons/external-store-buy-button'
import css from './shop-item-actions.scss'

const ShopItemActions = ({
  regItem,
  storeName,
  openGroupGiftRedemptionModal,
  openRedirectModal,
}) => {
  const {
    id,
    fundedAmount,
    isAvailableOnBabylist,
    isGroupGift,
    offers,
    productId,
    quantityNeeded,
  } = regItem
  const [quantity, setQuantity] = useState(quantityNeeded)
  const isGroupGiftWithFunds =
    isGroupGift && fundedAmount > 0 && isAvailableOnBabylist
  const isBabylistProduct =
    fundedAmount === 0 && isAvailableOnBabylist && storeName.match(/(babylist)/)
  const isExternalStore = !storeName.match(/(babylist|amazon)/)

  const AddToCartAction = () => {
    if (isBabylistProduct) {
      return (
        <AddToBabylistCartButton productId={productId} quantity={quantity} />
      )
    }

    // Group gift with funds
    if (isGroupGiftWithFunds) {
      // Open redemption modal with add to cart
      return (
        <InfoButton
          pill
          onClick={() =>
            openGroupGiftRedemptionModal(regItem, GROUP_GIFT_ACTIONS.QUICKADD)
          }
          style={{ minWidth: 150 }}
        >
          Add to Cart
        </InfoButton>
      )
    }

    // Out of stock
    if (storeName.match(/(babylist)/) && !isAvailableOnBabylist) {
      return (
        <InStockAlertButton
          text="In stock soon"
          buttonStyle={{ pill: true, empty: false, block: false }}
          productId={productId}
        />
      )
    }

    // External store
    return (
      <ExternalStoreBuyButton
        url={offers[0].url}
        openRedirectModal={openRedirectModal}
        storeDisplayName={offers[0].storeDisplayName}
        viglinkEnabled={offers[0].viglinkEnabled}
      />
    )
  }

  return (
    <>
      {isExternalStore && (
        <div
          className={classnames(
            'mrm mbn flex-grow btn btn-pill bas',
            css.quantityNeededWrapper
          )}
          empty
          pill
          style={{ borderWidth: 2, borderColor: '#f2f2f2', cursor: 'default' }}
        >
          <span className="text-brand-info text-weight-normal">
            Need: {quantity}
          </span>
        </div>
      )}
      {!isGroupGift && !isExternalStore && (
        <NumberSelect
          inline
          wrapperClassName="mrm mbn flex-grow"
          optionPrefix="Qty: "
          onChange={(e) => setQuantity(e.target.value)}
          min={1}
          max={10}
          pill
          value={quantity}
        />
      )}
      <div className={css.actionButton}>{AddToCartAction()}</div>
    </>
  )
}

ShopItemActions.propTypes = {
  regItem: PropTypes.object.isRequired,
  quantityNeeded: PropTypes.number.isRequired,
  openGroupGiftRedemptionModal: PropTypes.func.isRequired,
  openRedirectModal: PropTypes.func.isRequired,
  storeName: PropTypes.string.isRequired,
}

export default connect(undefined, { openGroupGiftRedemptionModal })(
  ShopItemActions
)
